import { Modal } from 'antd';
import styled from 'styled-components';

export const ResetPassModal = styled(Modal)`
    width: 680px !important;
    height: 409px !important;

    .ant-modal-body {
        padding: 32px 40px 40px 40px;
    }

    .ant-modal-content {
        border-radius: 6px;
    }
`;
